/**
 * getColumnLabel.ts
 *
 * Strips the leading model-name segment from a dotted column key when it
 * matches the table's own model — so `well.depth_m` renders as `depth_m`,
 * but cross-model `pipelineSurvey.name` keeps its prefix.
 */

import type { ModelName } from "@/endlaFunctions/customTypings/ecTypes";

export function getColumnLabel(modelName: ModelName, columnKey: string) {
  const [filterModelName, ...parts] = columnKey.split(".");
  if (filterModelName === modelName) {
    return parts.join(".");
  }
  return columnKey;
}
